import { render, staticRenderFns } from "./PunchIn.vue?vue&type=template&id=2d92f59c&scoped=true"
import script from "./PunchIn.vue?vue&type=script&lang=js"
export * from "./PunchIn.vue?vue&type=script&lang=js"
import style0 from "./PunchIn.vue?vue&type=style&index=0&id=2d92f59c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d92f59c",
  null
  
)

export default component.exports